export default function PromoModal({ show, onClose }) {
  if (!show) return null;

  return (
    <div className="blurred-app-state">
      <div className="modal-card">
        <button className="sidebar-close-btn" onClick={onClose}>&times;</button>
        <h2>A Welcome Gift!</h2>
        <p className="promo-text">To celebrate your first game, enjoy 10% off your next meal at our partner venue!</p>
        <div className="promo-venue-card">
          <h3>Clem's Tap House</h3>
          <a href="http://clemstaphouse.com/" target="_blank" rel="noreferrer" className="promo-link">Visit Website</a>
        </div>
        <p className="promo-subtext">Show this screen to your server to redeem.</p>
        <button className="btn-bank" style={{ marginTop: 20 }} onClick={onClose}>Got It!</button>
      </div>
    </div>
  );
}
